module.exports = __webpack_public_path__ + "static/filtrated-selected-a2dfb95cd2e64313617cf59c346f5bc5.svg";